// Lightgallery jquery version! https://github.com/sachinchoolur/lg-video
// Not lightgallery.js because it gave errors.



// WEBPACK FOOTER //
// ./scripts/routes/components/media.js